import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  padding: 0,
  marginBottom: theme.spacing(4),
  marginTop: theme.spacing(2.5),
  [theme.breakpoints.down('lg')]: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(0.625),
  },
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(3),
    marginTop: 0,
  },
  '& .RSPaggingContiner': {
    marginTop: theme.spacing(3),
  },
}));

export default StyledBox;
